import React, { useState } from 'react';
import { translate } from '../../Services/translation';

const MyPagesService = (props) => {
    const [searchError, setSearchError] = useState(null);
    const [isLoading, setIsLoading] = useState<boolean>(false);

    const openServiceLink = (e: any) => {
        e.preventDefault();
        if (props.serviceUrl) window.open(props.serviceUrl, '_blank');
    };

    const openPortaProLink = (e: any) => {
        e.preventDefault();
        if (props.portaProUrl) window.open(props.portaProUrl, '_blank');//Make it editable in Litium Backoffice
    };

    return (
        <div className="col-span-2">
            <h1 className="mb-2">{translate('mypage.service.title')}</h1>
            <p className="mb-4 max-w-3xl text-lg lg:mb-6">
                {translate('mypage.service.description')}
            </p>

            <p className="mb-4 max-w-3xl text-lg lg:mb-6">
                <a onClick={openPortaProLink}>{translate('mypage.service.alert.portapro')}</a>
            </p>

            {searchError && <p className="error">{searchError}</p>}

            <button
                className="btn btn--large btn--primary mt-2 lg:mt-4"
                disabled={isLoading}
                onClick={openServiceLink}
            >
                {translate('form.service.open')}
            </button>

        </div>
    );
};

export default MyPagesService;